import {Divider, Grid, Stack, Typography} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { practicesListSummaryState } from "../../../state";

const ToolbarInfo = () => {

    const { t } = useTranslation('expiredManagement');

    const summary = useRecoilValue(practicesListSummaryState);

    return (
        <Stack direction="row" alignItems="center" columnGap={1.5} px={2} py={.5} overflow="hidden">
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Typography>{t('searchExpired.summary.total')}:</Typography>
                <Typography>{summary?.total || 0}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Typography>{t('searchExpired.summary.nuovo')}:</Typography>
                <Typography>{summary?.nuovo || 0}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Typography>{t('searchExpired.summary.sms1')}:</Typography>
                <Typography>{summary?.sms1 || 0}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Typography>{t('searchExpired.summary.sms2')}:</Typography>
                <Typography>{summary?.sms2 || 0}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Typography>{t('searchExpired.summary.sms3')}:</Typography>
                <Typography>{summary?.sms3 || 0}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Typography>{t('searchExpired.summary.diffida')}:</Typography>
                <Typography>{summary?.diffida || 0}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Typography>{t('searchExpired.summary.affidoSocEsterna')}:</Typography>
                <Typography>{summary?.affidoSocEsterna || 0}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Typography>{t('searchExpired.summary.daQuerale')}:</Typography>
                <Typography>{summary?.daQuerale || 0}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Typography>{t('searchExpired.summary.chiusoQuerela')}:</Typography>
                <Typography>{summary?.chiusoQuerela || 0}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Typography>{t('searchExpired.summary.chiuso')}:</Typography>
                <Typography>{summary?.chiuso || 0}</Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
        </Stack>
    );
};

export default ToolbarInfo;
